export function deriveOfficeIntegrationState(data, hasError) {
    if (hasError) {
        return 'not-connected';
    }
    if (!data) {
        return undefined;
    }
    if (!data.companyId) {
        return 'not-connected';
    }
    return data.clientId ? 'linked' : 'unlinked';
}
